import N8nNotice from './Notice.vue';

export default N8nNotice;
